import { useState } from 'react';
import useLocalStorage from './useLocalstorage';
import { IS_DEVELOPMENT_ENV } from '../../config';

function useSmartStorage<T>(key: string, initialValue: T | (() => T)) {
    const [localValue, setLocalValue] = useLocalStorage<T>(key, initialValue);
    const [memoryValue, setMemoryValue] = useState<T>(
        initialValue instanceof Function ? initialValue() : initialValue,
    );

    if (IS_DEVELOPMENT_ENV) {
        return [localValue, setLocalValue] as const;
    } else {
        return [memoryValue, setMemoryValue] as const;
    }
}

export default useSmartStorage;
